export const title = 'Average conversion';
import ConversionAttributionNote from '../../shared/partials/conversion-attribution-note.en.mdx';

Average conversion rate across all sent campaigns.

A campaign's conversion rate is `qtd_vendas_atribuidas / qtd_aberturas`.

Where `qtd_vendas_atribuidas` is the number of sales attributed to the campaign and `qtd_aberturas` is how many people opened the notification sent by the campaign.

<ConversionAttributionNote />
